import { type ComponentProps } from "react";

import { useField } from "@conform-to/react";

import { cn } from "~/lib/utils";

export function FieldError({ name, className, ...props }: { name: string } & ComponentProps<"div">) {
    const [meta] = useField(name);
    if (meta.errors) {
        return (
            <div id={meta.errorId} className={cn("text-sm text-destructive", className)} {...props}>
                {meta.errors}
            </div>
        );
    } else {
        return null;
    }
}
